var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg62 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 3.4)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M10.696 5.998c.504 0 .99.08 1.446.226l.122.043a9.24 9.24 0 0 0-1.935 4.929h-.532a6.17 6.17 0 0 0-3.521 1.096 4.698 4.698 0 0 1 4.42-6.294"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  y: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 2.474,
  y: 3.923,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(45 4.723 4.723)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.599,
  height: 4.498,
  x: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M26.18 9.097a5.64 5.64 0 0 1 5.233 3.519l.084.22.265.75h-9.436l-2.395 8.505h-1.273a3.255 3.255 0 0 1-3.265-3.245 3.254 3.254 0 0 1 3.08-3.24l.185-.005h1.788l.116-1.373c.243-2.889 2.68-5.131 5.617-5.131m-6.6-4.899A7.78 7.78 0 0 1 26.014 7.6c-3.58.08-6.51 2.789-6.922 6.265l-.024.238h-.41c-2.632 0-4.764 2.124-4.764 4.744 0 1.172.426 2.245 1.133 3.072l.156.174H9.797A4.698 4.698 0 0 1 9.58 12.7l.216-.005h1.91l.116-1.374a7.785 7.785 0 0 1 7.757-7.123m14.217 9.567c2.314 0 4.187 1.865 4.187 4.163 0 2.228-1.761 4.05-3.978 4.158l-.209.006h-.817l1.516-2.519h-5.222l2.57-5.76.069.194 1.228-.192q.323-.05.656-.05"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M25.396 24.573h-4.605l2.671-9.487h6.171l-2.671 5.987h4.882l-9.027 15.013z"
}))));
export { Svg62 as ReactComponent };